
import axios from 'axios';
import qs from 'qs';
import Categories from '../src/config/Categories';

const SEARCH_MIN_NUMBER_OF_RESULTS = 8

export function getManufacturer(tid, nodeType) {
    return axios.get(`tql?q=MATCH (${nodeType}:s {technopedia_id: "${tid}"})<-[VENDOR_OF:v]-(MANUFACTURER:m) RETURN m.title`)
}

export function getAlternativeProducts(from, size, category) {
    const params = {
        from,
        size,
        filter_category: category,
        sort: 'title',
        q: 'match_all'
    }

    return axios.get(`search`, {
        params,
        paramsSerializer: function(param) {
            return qs.stringify(param, {arrayFormat: 'repeat'})
         },
    });
}

export function getCustomerView() {
    return axios.get('customer-view')
}

export function getStaticCategories(type) {
    return type.toLowerCase() === "software" ? Categories.Software : Categories.Hardware;
}

export function getAlternativeCPUs(tid, limit) {
    return axios.get(`tql?q=MATCH (CPU:a)<-[VENDOR_OF:v]-(MANUFACTURER:m) WHERE a.technopedia_id != "${tid}" RETURN a.title, m.title LIMIT ${limit}`)
}

export function getTidLookup(tid) {
    return axios.get(`technopedia-id/${tid}`)
}

export function executeQuery(query) {
    return axios.get(`tql`, {
        params: {
            q: query
        },
        paramsSerializer: function(param) {
            return qs.stringify(param)
        }
    });
}

export function getAllCategories() {
    return axios.get(`search?q=match_all&search_field=category`)
}

export function getVendors(query, filters) {
    var params = {
        q: query,
        search_field: 'vendor',
    }

    if (filters && filters.length > 0) {
        params = createFilterURLParams(filters, 'category', params);
    }

    return axios.get(`search`, {
        params,
        paramsSerializer: function(param) {
            return qs.stringify(param, {arrayFormat: 'repeat'})
         }
    })
}

function createFilterURLParams(filters, key, params) {
    for (let i = 0; i < filters.length; i++) {
        // If params has already a property with the key we simply append to it,
        // otherwise we define an array property on params an append the filter
        if (params.hasOwnProperty('filter_' + key)) {
            // Add to the existing array
            let filter = filters[i].toLowerCase();
            let subsequentFilter = filter[Object.keys(filters[i])[0]];

            // Get the filter array and append the filter to it
            let filterArray = params['filter_' + key];
            filterArray.push(subsequentFilter);
            return params;
        } else {
            let filterForKey = filters[i];
            let singleArray = [filterForKey];
            Object.defineProperty(params, 'filter_' + key, {value: singleArray, enumerable: true});
            return params;
        }
    }

}

export function getAssetsMatching(term, filters, sort, from = 0, size = SEARCH_MIN_NUMBER_OF_RESULTS) {
    const params = {
        q: term,
        sort,
        from,
        size,
    }

    if (filters) {
        // Transform filters to the correct data structure and appends it to params [{CATEGORY: `notebooks`}, {CATEGORY: `xyz`}, {VENDOR: 'dell'}];
        // Really bad performance method log(n)2
        for (let i = 0; i < filters.length; i++) {
            let key = Object.keys(filters[i])[0];

            // If params has already a property with the key we simply append to it,
            // otherwise we define an array property on params an append the filter
            if (params.hasOwnProperty('filter_' + key)) {
                // Add to the existing array
                let filter = filters[i]
                let subsequentFilter = filter[Object.keys(filters[i])[0]];

                // Get the filter array and append the filter to it
                let filterArray = params['filter_' + key];
                filterArray.push(subsequentFilter);
            } else {
                let filterForKey = filters[i][key];
                let singleArray = [filterForKey];
                Object.defineProperty(params, 'filter_' + key, {value: singleArray, enumerable: true, writable: true});
            }

            // Ensure that all filter properties are lowercase
            params['filter_' + key] = params['filter_' + key].map((filter) => {
                return filter;
            });
        }
    }

    return axios.get(`search`, {
        params,
        paramsSerializer: function(param) {
            return qs.stringify(param, {arrayFormat: 'repeat'})
         },
    });
}



// WEBPACK FOOTER //
// ./src/Api.js